import React from "react"

export function SaveDesignDialog({ saveDesignName, setSaveDesignName, saveToStudio, setSaveToStudio, userStudios, onSave, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Save Design</h2>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Design Name</label>
              <input
                type="text"
                value={saveDesignName}
                onChange={e => setSaveDesignName(e.target.value)}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    onSave()
                  } else if (e.key === "Escape") {
                    onClose()
                  }
                }}
                onFocus={e => e.target.select()}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter design name"
                autoFocus
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Save Location</label>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="saveLocation"
                    checked={saveToStudio === null}
                    onChange={() => setSaveToStudio(null)}
                    className="mr-2"
                  />
                  <span>Personal Designs</span>
                </label>

                {userStudios.map(studio => (
                  <label key={studio.id} className="flex items-center">
                    <input
                      type="radio"
                      name="saveLocation"
                      checked={saveToStudio === studio.id}
                      onChange={() => setSaveToStudio(studio.id)}
                      className="mr-2"
                    />
                    <span>{studio.name} (Studio)</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="flex gap-3 mt-6">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
            >
              Cancel
            </button>
            <button onClick={onSave} className="flex-1 px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors">
              Save Design
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

